import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';
import { AnimationEvent } from '@angular/animations';

import { AnimationService } from '../../services/animation/animation.service';

@Component({
    selector: 'app-background-image',
    templateUrl: './background-image.component.html',
    styleUrls: ['./background-image.component.scss'],
    animations: [
        AnimationService.fadeInOutFixed()
    ]
})
export class BackgroundImageComponent implements OnChanges {
    @Input() src: string;
    @Input() id: number;
    @Input() zIndex: number;

    @Input() index: number;
    @Input() previousIndex: number;

    @Output() error = new EventEmitter();
    @Output() transitionIn = new EventEmitter();

    _src: string;

    ready: boolean;
    visible: boolean;

    ngOnChanges (changes: SimpleChanges) {
        if (this.src) {
            // preload the image
            if (this.index === this.id) {
                // preload
                this._src = this.src;
            }
            // show the image
            this.visible = (this.index === this.id || this.previousIndex === this.id);
        }
    }

    onLoaded (event: Event) {
        this.ready = true;
    }

    onError (event: Event) {
        // tell the parent that the image failed to load
        this.error.emit({
            value: this.id
        });
    }

    transitionDone (event: AnimationEvent) {
        // only report this when animation is fading IN
        if (event.toState === 'active') {
            this.transitionIn.emit({
                value: this.id
            });
        }
    }
}
